import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsAlternative from "../generic-nav-bar/NavbarIconsAlternative";
import useFormValidations from "../../app/hooks/useFormValidations";
import { useHydrateViewCatalogRelations } from "../../app/hooks/useHydrateViewCatalogRelations";
import { Link } from "react-router-dom";
import { startLoadingCatalogCiiusAll } from "../../app/actions/catalogCiiuActions";
import { startLoadingCatalogSectionsAll } from "../../app/actions/catalogSectionActions";
import { startLoadingCatalogPhasesAll } from "../../app/actions/catalogPhaseActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import ViewProblemTableAlternative from "../end-user-search/ViewProblemTableAlternative";
import IntegrationViewChrome from "../end-user-search/IntegrationViewChrome";
import { useIntegrationNestedPreview } from "../end-user-search/integrationNestedPreviewContext";
import DetailSectionsLayout from "../end-user-search/DetailSectionsLayout";
import { getSectionHeader } from "../../app/helpers/helperValidationViewPreview";

const PreviewAlternative = () => {
  debugLogPages(':: PreviewAlternative');
  const dispatch = useDispatch();
  const { nested, setDetailMode } = useIntegrationNestedPreview();

  const { t } = useTranslation();

  /********Store*******/
  const { alternativeSelected } = useSelector((state) => state.alternative);

  const { listFieldsAlternativeView, listFieldsAlternativePreview } = useSelector((state) => state.moduleConfig);

  /********UseForm*******/
  const { values, setValues } = useFormValidations(
    () => AlternativeCallback(),
    alternativeSelected,
    listFieldsAlternativeView
  );

  const AlternativeCallback = () => {
    
  };

  useHydrateViewCatalogRelations('Alternative', values, setValues);

  useEffect(() => {
    /*JT Load Please */
    dispatch(startLoadingCatalogCiiusAll());
    dispatch(startLoadingCatalogSectionsAll());
    dispatch(startLoadingCatalogPhasesAll());

    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());

  }, [])

  const { arrayListPrincipal, arrayListSecondary } = listFieldsAlternativePreview;

  const alternativeViewRelations = {
    multimedia: "ModuleFile_To_Alternative",
    problems: "ModuleProblem_To_Alternative"
  };

  const sharedViewProps = {
    values,
    t,
    ProblemTableComponent: ViewProblemTableAlternative,
    relationKeys: alternativeViewRelations,
    isPreviewMode: true // Evalúa show_view_preview
  };

      const principalHeader = getSectionHeader(arrayListPrincipal);
      const secondaryHeader = getSectionHeader(arrayListSecondary);

  const onGoFullVersion = (e) => {
    if (!nested || !setDetailMode) return;
    e.preventDefault();
    setDetailMode('view');
  };

  return (
    <div>
      {!nested && <NavbarIconsAlternative page={"viewText"} />}

      {!nested && (
        <IntegrationViewChrome
          sourceModuleKey="alternative"
          record={alternativeSelected}
        />
      )}

      <div className="d-flex justify-content-center page-title">{t("alternative.preview.title")}</div>
      <hr className="line-hr" />
      <div className="section is-fullheight">
        <div className="container">
          <form>
            <div className="container-fluid">
              <div className="text-center fw-bolder">
                <div className="text-center">
                  {nested ? (
                    <button
                      type="button"
                      className="btn btn-link p-0 fw-bolder"
                      onClick={onGoFullVersion}
                    >
                      {t("alternative.preview.redirect")}
                    </button>
                  ) : (
                    <Link to="/end-user-search/view-alternative">
                      {t("alternative.preview.redirect")}
                    </Link>
                  )}
                </div>
              </div>

              <DetailSectionsLayout
                nested={nested}
                isPreviewMode
                arrayListPrincipal={arrayListPrincipal}
                arrayListSecondary={arrayListSecondary}
                principalHeader={principalHeader}
                secondaryHeader={secondaryHeader}
                sharedViewProps={sharedViewProps}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PreviewAlternative;
